"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePropertyPolicyHolderSchema = exports.impossiblePolicyHolderBirthdayRangeSchema = exports.impossiblePolicyholderBirthdayStringSchema = exports.MAX_PROPERTY_POLICYHOLDER_AGE_IN_YEARS = exports.MIN_PROPERTY_POLICYHOLDER_AGE_IN_YEARS = void 0;
const zod_1 = require("zod");
const PolicyHolder_1 = require("./PolicyHolder");
const BirthdayRange_1 = require("./BirthdayRange");
const dates_1 = require("../dates");
exports.MIN_PROPERTY_POLICYHOLDER_AGE_IN_YEARS = 18;
exports.MAX_PROPERTY_POLICYHOLDER_AGE_IN_YEARS = 122;
exports.impossiblePolicyholderBirthdayStringSchema = (0, dates_1.dateInYearsRangeStringSchemaFactory)(exports.MIN_PROPERTY_POLICYHOLDER_AGE_IN_YEARS, exports.MAX_PROPERTY_POLICYHOLDER_AGE_IN_YEARS, `Property policyholder can not be younger than ${exports.MIN_PROPERTY_POLICYHOLDER_AGE_IN_YEARS} years old or older than ${exports.MAX_PROPERTY_POLICYHOLDER_AGE_IN_YEARS} years old`);
exports.impossiblePolicyHolderBirthdayRangeSchema = BirthdayRange_1.impossibleBirthdayRangeSchema
    .extend({
    start: zod_1.z.optional(exports.impossiblePolicyholderBirthdayStringSchema),
    end: zod_1.z.optional(exports.impossiblePolicyholderBirthdayStringSchema),
})
    .strict();
exports.impossiblePropertyPolicyHolderSchema = PolicyHolder_1.impossiblePolicyHolderSchema.extend({
    birthday: zod_1.z.nullable(exports.impossiblePolicyholderBirthdayStringSchema),
    birthdayRange: zod_1.z.nullable(exports.impossiblePolicyHolderBirthdayRangeSchema),
}).strict();
